var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v(_vm._s(_vm.groupInfo.groupName))])]
          ),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-top": "-66px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.currentChangeHandle(1)
                    },
                  },
                },
                [_vm._v("刷新参数列表")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addOrUpdateHandle(_vm.groupId)
                    },
                  },
                },
                [_vm._v("修改分组")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.deleteHandle(_vm.groupId)
                    },
                  },
                },
                [_vm._v("删除分组")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.deleteSelectItem()
                    },
                  },
                },
                [_vm._v("删除子项")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.newItemHandle(_vm.groupId)
                    },
                  },
                },
                [_vm._v("新增子项")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.chooseItemHandle(_vm.groupId)
                    },
                  },
                },
                [_vm._v("选择数据项目")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dataListLoading,
                  expression: "dataListLoading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.dataList,
                "row-key": "id",
                border: "",
                stripe: "",
              },
              on: { "selection-change": _vm.selectionChangeHandle },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  type: "index",
                  align: "center",
                  label: "序号",
                  width: "50",
                  index: _vm.getRowsIndex,
                },
              }),
              _c("el-table-column", {
                attrs: { type: "selection", align: "center", fixed: "" },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  align: "center",
                  width: "100",
                  label: "操作",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.addOrUpdateItemHandle(
                                  scope.row.id,
                                  scope.row.formId,
                                  scope.row.groupId
                                )
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteHandleField(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  prop: "columnName",
                  "header-align": "left",
                  align: "left",
                  width: "120",
                  label: "字段名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "columnType",
                  "header-align": "left",
                  align: "left",
                  width: "120",
                  label: "字段类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatterDataDictionary(
                                _vm.columnTypeList,
                                scope.row.columnType
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "displayName",
                  "header-align": "left",
                  align: "left",
                  width: "150",
                  label: "显示名",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "showInList",
                  align: "center",
                  width: "80",
                  label: "是否显示",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.showInList === true
                          ? _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v("是"),
                            ])
                          : _vm._e(),
                        scope.row.showInList === false
                          ? _c(
                              "el-tag",
                              { attrs: { size: "small", type: "danger" } },
                              [_vm._v("否")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "textType",
                  align: "center",
                  width: "80",
                  label: "是否显示显示名",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.textType == 1
                          ? _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v("是"),
                            ])
                          : _c(
                              "el-tag",
                              { attrs: { size: "small", type: "danger" } },
                              [_vm._v("否")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "isQueryParam",
                  align: "center",
                  width: "80",
                  label: "是否为查询参数",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isQueryParam
                          ? _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v("是"),
                            ])
                          : _c(
                              "el-tag",
                              { attrs: { size: "small", type: "danger" } },
                              [_vm._v("否")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "datasourceType",
                  "header-align": "left",
                  width: "100",
                  align: "left",
                  label: "数据源类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatterDataDictionary1(
                                _vm.datasourceTypeList,
                                scope.row.datasourceType
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "datasource",
                  "header-align": "left",
                  align: "left",
                  label: "数据源",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "columnCount",
                  align: "center",
                  width: "115",
                  label: "列数",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.columnCount == 3
                          ? _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v("三列"),
                            ])
                          : scope.row.columnCount == 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v("双列")]
                            )
                          : scope.row.columnCount == 1
                          ? _c(
                              "el-tag",
                              { attrs: { size: "small", type: "danger" } },
                              [_vm._v("单列(整行)")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  width: "80",
                  align: "center",
                  label: "排序",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.addOrUpdateVisible
        ? _c("add-or-update", {
            ref: "addOrUpdate",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
      _vm.addOrUpdateItemVisible
        ? _c("add-or-update-item", {
            ref: "addOrUpdateItem",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
      _vm.chooseItemVisible
        ? _c("choose-item", {
            ref: "chooseItem",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }